<template>
  <div class="d-flex align-center" style="width: 100%">
    <!-- <div>
      <v-btn variant="text" color="primary">
        <v-icon start large color="primary">mdi-calendar</v-icon>
        <div class="pl-2 date-button">{{ formattedDate }}</div>
      </v-btn>
    </div> -->

    <v-menu
      ref="menu"
      v-model="open"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ props }">
        <v-btn variant="text" color="primary" v-bind="props" large>
          <div class="d-flex align-center">
            <v-icon start size="x-large" color="primary">mdi-calendar</v-icon>
            <div class="pl-2 date-button">{{ formattedDate }}</div>
          </div>
        </v-btn>
      </template>
      <v-card variant="flat" elevation="4" class="bg-white">
        <v-locale-provider locale="ja">
          <v-date-picker
            :model-value="modelValue"
            @update:model-value="updateValue"
            color="primary"
            variant="flat"
            hide-details
          >
          </v-date-picker>
        </v-locale-provider>
      </v-card>
    </v-menu>

    <div>
      <v-btn @click="subtract" variant="text" color="primary">
        <v-icon start>mdi-chevron-left</v-icon>
        前日
      </v-btn>
    </div>
    <div>
      <v-btn @click="add" variant="text" color="primary">
        次の日
        <v-icon end>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/ja";

export default defineComponent({
  name: "DatePager",

  emits: ["update:modelValue", "change"],

  props: {
    modelValue: {
      type: String,
      required: false,
    },
  },

  mounted() {
    dayjs.locale("ja");

    //localStorageから日付を取得
    this.savedDate = "";
    if (localStorage.getItem('date')) {
      this.savedDate = localStorage.getItem('date');
      localStorage.removeItem('date');
      this.$emit('update:modelValue', this.savedDate);
    }
  },

  watch: {
    date: {
      immediate: true,
      handler(val) {
        this.$emit("change", dayjs(val).format("YYYY-MM-DD"));
      },
    },
  },

  data() {
    return {
      date: dayjs() as Dayjs,
      formatString: "YYYY年MM月DD日 (ddd)",
      open: false,
      savedDate: '' as any,
    };
  },

  computed: {
    formattedDate(): string {
      if (this.modelValue) {
        return dayjs(this.modelValue).format(this.formatString);
      }
      return dayjs(this.date).format(this.formatString);
    },
  },

  methods: {
    add() {
      if (this.modelValue) {
        const newValue = dayjs(this.modelValue).add(1, "day").format("YYYY-MM-DD");
        this.$emit("update:modelValue", newValue);
        return;
      }
      this.date = dayjs(this.date).add(1, "day");
    },
    subtract() {
      if (this.modelValue) {
        const newValue = dayjs(this.modelValue)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
        this.$emit("update:modelValue", newValue);
        return;
      }
      this.date = dayjs(this.date).subtract(1, "day");
    },
    updateValue(date: string | Dayjs) {
      const newDate = dayjs(date).format("YYYY-MM-DD");
      this.$emit("update:modelValue", newDate);
      this.open = false;
    },
  },
});
</script>

<style scoped>
.date-button {
  font-size: 1.4rem;
}
</style>
